import {RelatedLink} from "../utils";

export const frRelatedLinks: RelatedLink[] = [];
